import React, { HTMLAttributes } from 'react'
import { BsFillCloudArrowUpFill, BsFillCloudCheckFill, BsImage, BsPatchQuestion } from 'react-icons/bs'
import { FaDownload, FaRegEnvelopeOpen, FaCheck, FaCaretUp, FaCaretDown } from 'react-icons/fa6'
import { TbCircleDashedNumber7, TbMapPinFilled, TbLibraryPlus, TbBrandStackshare } from 'react-icons/tb'
import { IoIosArrowBack, IoIosArrowForward, IoIosHelpCircleOutline, IoIosSave, IoMdHome, IoIosCheckboxOutline, IoIosArrowDown } from 'react-icons/io'
import { GrApps, GrDocumentPerformance } from 'react-icons/gr'
import { PiBriefcaseLight, PiUploadLight, PiUserList } from 'react-icons/pi'
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdKeyboardArrowRight, MdAddChart, MdRefresh, MdOutlineKeyboardCommandKey, MdOutlineAnalytics } from 'react-icons/md'
import { BiBell, BiSearchAlt, BiSolidDropletHalf, BiSolidEnvelope, BiSolidPhoneCall, BiSolidUserCircle } from 'react-icons/bi'
import LoaderSVG from './iconSvgs/loader'
import BackgroundSvg from './pageSvgs/backgoround'
import DoneSVG from './iconSvgs/Done'
import CircleDown from './iconSvgs/circleDown'
import PencilIcon from './iconSvgs/pencil'
import ScriptRunSVG from './iconSvgs/scriptRun'
import { IoEyeOutline, IoTrashOutline, IoClose, IoWarning, IoCloseCircle, IoEarth, IoCalendarOutline, IoFilter, IoAppsSharp, IoLanguage, IoSettingsOutline, IoShareSocialSharp } from 'react-icons/io5'
import TwoSquareIcon from './iconSvgs/twoSquare'
import NegativeChartIcon from './iconSvgs/negativeChart'
import PositiveChartIcon from './iconSvgs/positiveChart'
import { FiCopy, FiUploadCloud, FiLogOut, FiPlus, FiMinus } from 'react-icons/fi'
import { HiOutlineLightBulb } from 'react-icons/hi'
import { RiDeleteBinLine, RiAdminLine, RiSwapBoxFill, RiLinkM } from 'react-icons/ri'
import { FaCircleNotch, FaLessThan } from 'react-icons/fa'
import { AiFillPlusCircle, AiOutlineInfoCircle, AiFillCheckCircle, AiFillCode, AiOutlinePlusCircle, AiFillFolderAdd } from 'react-icons/ai'
import EditIcon from './iconSvgs/edit'
import { LuCheck, LuClock2, LuPlus } from 'react-icons/lu'
import BarChartSVG from './iconSvgs/barChart'
import { VscGraph, VscGraphLine } from 'react-icons/vsc'
import { CiCircleCheck, CiPause1, CiPlay1 } from 'react-icons/ci'
import { GoPlus } from 'react-icons/go'
import RepeatIcon from './iconSvgs/repeat'
import NoteSVG from './iconSvgs/note'
import TimerSVG from './iconSvgs/timer'
import RecurringSVG from './iconSvgs/recurring'
import { SlArrowRight } from 'react-icons/sl'
import { iconNames } from '../_config/types'

interface Props extends HTMLAttributes<HTMLElement> {
    name: iconNames
    size?: any
    className?: string
    title?: string
    onClick?: (e: any) => void
    ref?: any
}

const Icon: React.FC<Props> = ({ name, size = '1', className = '', title = '', onClick, ref, ...args }) => {
    const iconMap: Record<string, JSX.Element> = {
        number: <TbCircleDashedNumber7 style={{ fontSize: `${size}rem` }} />,
        image: <BsImage style={{ fontSize: `${size}rem` }} />,
        download: <FaDownload style={{ fontSize: `${size}rem` }} />,
        'download-alt': <img alt="download" src="/download-alt.svg" style={{ fontSize: `${size}rem` }} />,
        'download-alt1': <img alt="download" src="/download-alt1.svg" style={{ fontSize: `${size}rem` }} />,
        save: <IoIosSave style={{ fontSize: `${size}rem` }} />,
        logout: <FiLogOut style={{ fontSize: `${size}rem` }} />,
        user: <BiSolidUserCircle style={{ fontSize: `${size}rem` }} />,
        search: <BiSearchAlt style={{ fontSize: `${size}rem` }} />,
        bell: <BiBell style={{ fontSize: `${size}rem` }} />,
        apps: <GrApps style={{ fontSize: `${size}rem` }} />,
        down: <MdKeyboardArrowDown style={{ fontSize: `${size}rem` }} />,
        up: <MdKeyboardArrowUp style={{ fontSize: `${size}rem` }} />,
        right: <MdKeyboardArrowRight style={{ fontSize: `${size}rem` }} color={args?.color} />,
        'right-big': <SlArrowRight style={{ fontSize: `${size}rem` }} color={args?.color} />,
        call: <BiSolidPhoneCall style={{ fontSize: `${size}rem` }} />,
        envelop: <BiSolidEnvelope style={{ fontSize: `${size}rem` }} />,
        mappin: <TbMapPinFilled style={{ fontSize: `${size}rem` }} />,
        warning: <IoWarning style={{ fontSize: `${size}rem` }} color={args?.color} />,
        loader: <LoaderSVG size={size} />,
        background: <BackgroundSvg size={size} />,
        done: <DoneSVG size={size} />,
        circleDown: <CircleDown size={size} color={args?.color} />,
        eye: <IoEyeOutline style={{ fontSize: `${size}rem` }} />,
        pencil: <PencilIcon size={size} color={args?.color} fill={args?.color} />,
        delete: <IoTrashOutline style={{ fontSize: `${size}rem` }} />,
        'add-multiple': <LuPlus style={{ fontSize: `${size}rem` }} />,
        twoSquares: <TwoSquareIcon size={size} color={args?.color} />,
        share: <IoShareSocialSharp style={{ fontSize: `${size}rem` }} />,
        'share-alt': <img alt="share" src="/share-alt.svg" style={{ height: `${size}rem` }} />,
        negativeChart: <NegativeChartIcon size={size} color={args?.color} />,
        positiveChart: <PositiveChartIcon size={size} color={args?.color} />,
        filledPlusCircle: <AiFillPlusCircle style={{ fontSize: `${size}rem` }} />,
        outlineInfoCircle: <AiOutlineInfoCircle style={{ fontSize: `${size}rem` }} />,
        emptyPlusCircle: <AiOutlinePlusCircle style={{ fontSize: `${size}rem` }} color={args?.color} />,
        'circle-check': <AiFillCheckCircle style={{ fontSize: `${size}rem` }} color={args?.color} />,
        'code-run': <AiFillCode style={{ fontSize: `${size}rem` }} color={args?.color} />,
        'arrow-right': <IoIosArrowForward style={{ fontSize: `${size}rem` }} />,
        'arrow-left': <IoIosArrowBack style={{ fontSize: `${size}rem` }} />,
        'add-more': <AiOutlinePlusCircle style={{ fontSize: `${size}rem` }} color={args?.color} />,
        check: <LuCheck style={{ fontSize: `${size}rem` }} />,
        'delete-stroke': <RiDeleteBinLine style={{ fontSize: `${size}rem` }} color={args?.color} />,
        copy: <FiCopy style={{ fontSize: `${size}rem` }} color={args?.color} />,
        profile: <PiUserList style={{ fontSize: `${size}rem` }} />,
        admin: <RiAdminLine style={{ fontSize: `${size}rem` }} />,
        'lib-plus': <TbLibraryPlus style={{ fontSize: `${size}rem` }} />,
        attachement: <RiLinkM style={{ fontSize: `${size}rem` }} />,
        upload: <FiUploadCloud style={{ fontSize: `${size}rem` }} />,
        edit: <EditIcon style={{ fontSize: `${size}rem` }} />,
        buttonLoader: <FaCircleNotch className="spinner" style={{ fontSize: `${size}rem` }} />,
        upFilled: <FaCaretUp style={{ fontSize: `${size}rem` }} />,
        downFilled: <FaCaretDown style={{ fontSize: `${size}rem` }} />,
        tickMark: <FaCheck style={{ fontSize: `${size}rem` }} />,
        lessThan: <FaLessThan style={{ fontSize: `${size}rem` }} />,
        close: <IoClose style={{ fontSize: `${size}rem` }} />,
        calendar: <IoCalendarOutline style={{ fontSize: `${size}rem` }} />,
        globe: <img alt="globe" src="/globe.svg" style={{ fontSize: `${size}rem` }} />,
        clock: <LuClock2 style={{ fontSize: `${size}rem` }} />,
        barChart: <BarChartSVG size={size} />,
        briefcase: <PiBriefcaseLight style={{ fontSize: `${size}rem` }} />,
        'earth ': <IoEarth style={{ fontSize: `${size}rem` }} />,
        chart: <VscGraph size={size} color={args?.color} />,
        'line-chart': <VscGraphLine size={size} color={args?.color} />,
        'solid-close': <IoCloseCircle style={{ fontSize: `${size}rem` }} />,
        reset: <MdRefresh style={{ fontSize: `${size}rem` }} />,
        pause: <CiPause1 style={{ fontSize: `${size}rem` }} />,
        play: <CiPlay1 style={{ fontSize: `${size}rem` }} />,
        'cloud-upload': <BsFillCloudArrowUpFill style={{ fontSize: `${size}rem` }} />,
        'cloud-check': <BsFillCloudCheckFill style={{ fontSize: `${size}rem` }} />,
        'envelop-open': <FaRegEnvelopeOpen style={{ fontSize: `${size}rem` }} />,
        filter: <IoFilter style={{ fontSize: `${size}rem` }} className={className} />,
        home: <IoMdHome style={{ fontSize: `${size}rem` }} />,
        createExperiment: <AiFillFolderAdd style={{ fontSize: `${size}rem` }} />,
        myExperiments: <IoAppsSharp style={{ fontSize: `${size}rem` }} />,
        resultTracking: <MdAddChart style={{ fontSize: `${size}rem` }} />,
        liveSimulation: <RiSwapBoxFill style={{ fontSize: `${size}rem` }} />,
        multiTreatment: <GrDocumentPerformance style={{ fontSize: `${size}rem` }} />,
        'script-run': <ScriptRunSVG size={size} />,
        recurring: <RecurringSVG size={size} />,
        bulb: <HiOutlineLightBulb style={{ fontSize: `${size}rem` }} />,
        goPlus: <GoPlus style={{ fontSize: `${size}rem` }} />,
        help: <IoIosHelpCircleOutline style={{ fontSize: `${size}rem` }} />,
        lang: <IoLanguage style={{ fontSize: `${size}rem` }} />,
        repeat: <RepeatIcon size={size} title={title} />,
        'square-check-box': <IoIosCheckboxOutline size={size} title={title} />,
        settings: <IoSettingsOutline size={size} title={title} />,
        note: <NoteSVG size={size} />,
        plus: <FiPlus style={{ fontSize: `${size}rem` }} />,
        minus: <FiMinus style={{ fontSize: `${size}rem` }} />,
        downArrow: <IoIosArrowDown style={{ fontSize: `${size}rem` }} />,
        MdOutlineKeyboardCommandKey: <MdOutlineKeyboardCommandKey style={{ fontSize: `${size}rem` }} />,
        drop: <BiSolidDropletHalf style={{ fontSize: `${size}rem` }} />,
        review: <img alt="review" src="/review.svg" style={{ height: `${size}rem` }} />,
        'recurring-expt': <img alt="recurring-expt" src="/recurring-expt.svg" style={{ fontSize: `${size}rem` }} />,
        scale: <img alt="scale" src="/scale.svg" style={{ fontSize: `${size}rem` }} />,
        'upload-1': <PiUploadLight style={{ fontSize: `${size}rem` }} />,
        'more-actions': <img alt="more-actions" src="/more-actions.svg" style={{ fontSize: `${size}rem` }} />,
        timer: <TimerSVG size={size} />,
        'share-icon': <TbBrandStackshare style={{ fontSize: `${size}rem` }} />,
        'question-mark': <BsPatchQuestion style={{ fontSize: `${size}rem` }} />,
        'circle-check-tick': <CiCircleCheck style={{ fontSize: `${size}rem` }} />,
        analytics: <MdOutlineAnalytics style={{ fontSize: `${size}rem` }} />,
    }

    const getStyle = () => {
        const style: any = {}
        if (onClick) style.cursor = 'pointer'
        return style
    }

    const icon = iconMap[name] || <></>

    if (onClick) {
        return (
            <button type="button" onClick={onClick} className={`${className} cursor-pointer`} style={getStyle()} ref={ref} {...args}>
                {icon}
            </button>
        )
    }

    return (
        <span className={`${className}`} style={getStyle()} ref={ref} {...args}>
            {icon}
        </span>
    )
}

export default Icon
